import { render } from "./desktop-header.vue?vue&type=template&id=c7ce4134&scoped=true"
import script from "./desktop-header.vue?vue&type=script&lang=js"
export * from "./desktop-header.vue?vue&type=script&lang=js"

import "../../../assets/css/desktop.css?vue&type=style&index=0&id=c7ce4134&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c7ce4134"

export default script